export default __webpack_public_path__ + "static/media/AcornOffice_41.893da183.png";